import BigNumber from 'bignumber.js/bignumber'

import BakerySwapPairAbi from './abi/BakerySwapPair.json'
import BakeryTokenAbi from './abi/BakeryToken.json'
import BakeryMasterAbi from './abi/BakeryMaster.json'
import ERC20Abi from './abi/erc20.json'
import ERC721Abi from './abi/erc721.json'
import WETHAbi from './abi/weth.json'
import DishAbi from './abi/dish.json'
import NFTHelperAbi from './abi/NFTHelper.json'
import DishMasterAbi from './abi/dishMaster.json'
import ExchangeNFTAbi from './abi/exchangeNFT.json'
import PetTokenAbi from './abi/petToken.json'
import PetMasterAbi from './abi/petMaster.json'
import PetMaster2Abi from './abi/petMaster2.json'
import PetEggNftAbi from './abi/petEggNft.json'
import DigitalArtworkNftAbi from './abi/BcaexOwnershipV2.json'
import WeaponMasterAbi from './abi/weaponMaster.json'
import WeaponTokenAbi from './abi/weaponToken.json'
import WeaponNftAbi from './abi/weaponNFT.json'
import BinanceNFTAbi from './abi/binanceNFT.json'
import CommonMasterAbi from './abi/commonMaster.json'
import BakeryArtworkNftAbi from './abi/artworkNFT.json'
import BakeryArtworkRouterAbi from './abi/artworkRouter.json'
import CommonNftMasterAbi from './abi/commonNftMaster.json'
import PetNftAbi from './abi/petNft.json'
import HelmetNftAbi from './abi/helmetNFT.json'
import Eth2MasterAbi from './abi/eth2Master.json'
import BidNFTAbi from './abi/bidNFT.json'
import BakeBaseMaster from './abi/bakeBaseMaster.json'
import BakeBaseIDO from './abi/bakeBaseIDO.json'
import VoteForNFTAbi from './abi/voteForNFT.json'
import BakerySoccerMasterAbi from './abi/bakerySoccerMaster.json'
import CommonStakeERC721EarnERC20Abi from './abi/commonStakeERC721EarnERC20.json'
import PokerBlindBoxAbi from './abi/PokerBlindBox.json'
import PokerCardAbi from './abi/PokerCard.json'
import PokerCardMasterAbi from './abi/PokerCardMaster.json'
import SoccerPokerGameBoxAbi from './abi/SoccerPokerGameBox.json'
import SoccerPokerGameBoxBurnByProxyAbi from './abi/SoccerPokerGameBoxBurnByProxy.json'
import CarBlindBoxAbi from './abi/CarBlindBox.json'
import CarNFTAbi from './abi/CarNFT.json'
import CarNFTMasterAbi from './abi/CarNFTMaster.json'
import DoggyNFTAbi from './abi/DoggyNFT.json'
import CommonStakeERC721EarnBakeAbi from './abi/CommonStakeERC721EarnBake.json'
import ExchangeNFTV2Abi from './abi/ExchangeNFTV2.json'
import BidNFTV2Abi from './abi/BidNFTV2.json'
import CreatorRoyaltiesNFTAbi from './abi/CreatorRoyaltiesNFT.json'
import BarkingNFTAbi from './abi/BarkingNFT.json'
import ExchangeNFTsAbi from './abi/ExchangeNFTs.json'
import DoggyEquipmentAbi from './abi/DoggyEquipment.json'
import MatrixPlusBoxAbi from './abi/MatrixPlusBox.json'
import SimpleStakeERC721EarnERC20Abi from './abi/SimpleStakeERC721EarnERC20.json'
import BakeMuskMixerAbi from './abi/BakeMuskMixer.json'
import MuskUsmLandAbi from './abi/MuskUsmLand.json'
import NewDonghuangArtAbi from './abi/NewDonghuangArt.json'
import SellNFTsAbi from './abi/SellNFTs.json'
import BmoncNFTAbi from './abi/bmoncNFT.json'

import {
  contractAddresses,
  SUBTRACT_GAS_LIMIT,
  supportedPools,
  supportedV2Pools,
  supportedPetPools,
  supportedNewPools,
  endedPools,
  otherPools,
  allNftPools,
  bPetPools,
  weaponPools,
  bestPools,
  weaponnftPools,
  petNftPools,
  helmetNftPools,
  eth2MasterPools,
  aethMasterPools,
  aethAndEth2Pools,
  springMasterPools,
  wSOTEMasterPools,
  SHIELDMasterPools,
  BRYMasterPools,
  supportedBakeStakingPools,
  DEFI100MasterPools,
  DEFI100OLDMasterPools,
  BananaMasterPools,
  seascapeNftPools,
  pCWSMasterPools,
  warMasterPools,
  war2MasterPools,
  tokocryptoNftPools,
  hatNftPools,
  dieselPools,
  mxMasterPools,
  aliceMasterPools,
  aliceNftPools,
  bondlyNftPools,
  tctMasterPools,
  dfyMasterPools,
  gfxMasterPools,
  xDittoMasterPools,
  sactMasterPools,
  pet3Pools,
  hyfiPools,
  ginuPools,
  levPools,
  bondlyPools,
  bondly2Pools,
  tkoPools,
  tkoNftPools,
  bakeMuskMixerNftPools,
  nftStakingPools,
  oneInchBakeNftPools,
  tko2Pools,
  bnrgPools,
  tlmPools,
  tsaPools,
  xdittoNftPools,
  doggyTlmPools,
  barkTlmPools,
  tokauTlmPools,
  toyNftPools,
  bmoncNftPools,
  gatTlmPools,
  wsgPools,
  dogoPools,
  toynftEarnPools,
  bethMasterPools,
  tokauPools,
  eggPools,
  kalataPools,
  donPools,
  ntPools,
  moniPools,
  kxaPools,
  nblPools
} from './constants.js'
import * as Types from './types.js'

export class Contracts {
  constructor(provider, networkId, web3, options) {
    this.web3 = web3
    this.defaultConfirmations = options.defaultConfirmations
    this.autoGasMultiplier = options.autoGasMultiplier || 1.5
    this.confirmationType = options.confirmationType || Types.ConfirmationType.Confirmed
    this.defaultGas = options.defaultGas
    this.defaultGasPrice = options.defaultGasPrice

    this.sushi = new this.web3.eth.Contract(BakeryTokenAbi)
    this.masterChef = new this.web3.eth.Contract(BakeryMasterAbi)
    this.weth = new this.web3.eth.Contract(WETHAbi)
    this.dish = new this.web3.eth.Contract(DishAbi)
    this.bakeBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.nftHelper = new this.web3.eth.Contract(NFTHelperAbi)
    this.dishMaster = new this.web3.eth.Contract(DishMasterAbi)
    this.exchangeNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidDishNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.pet = new this.web3.eth.Contract(PetTokenAbi)
    this.petMaster = new this.web3.eth.Contract(PetMasterAbi)
    this.petMaster2 = new this.web3.eth.Contract(PetMaster2Abi)
    this.petEggNft = new this.web3.eth.Contract(PetEggNftAbi)
    this.exchangeEggNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidPetEggNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.digitalArtworkNft = new this.web3.eth.Contract(DigitalArtworkNftAbi)
    this.exchangeArtworkNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidDigitalArtworkNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.weapon = new this.web3.eth.Contract(WeaponTokenAbi)
    this.weaponBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.weaponNFT = new this.web3.eth.Contract(WeaponNftAbi)
    this.weaponMaster = new this.web3.eth.Contract(WeaponMasterAbi)
    this.exchangeWeaponNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidWeaponNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.binanceNft = new this.web3.eth.Contract(BinanceNFTAbi)
    this.exchangeBinanceNft = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBinanceNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.bestToken = new this.web3.eth.Contract(ERC20Abi)
    this.bestMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.bakeryArtworkNFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeBakeryArtworkNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBakeryArtworkNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.bakeryArtworkRouter = new this.web3.eth.Contract(BakeryArtworkRouterAbi)
    this.weaponNFTCommonMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.petNFTCommonMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.petNft = new this.web3.eth.Contract(PetNftAbi)
    this.exchangePetNft = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidPetNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.bakeryArtwork2NFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeBakeryArtwork2NFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBakeryArtwork2NFT = new this.web3.eth.Contract(BidNFTAbi)
    this.dogeMemeNFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeDogeMemeNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidDogeMemeNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.helmetNft = new this.web3.eth.Contract(HelmetNftAbi)
    this.helmetNftCommonMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.eth2Master = new this.web3.eth.Contract(Eth2MasterAbi)
    this.bethBakeBLP = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.beth = new this.web3.eth.Contract(ERC20Abi)
    this.ten = new this.web3.eth.Contract(ERC20Abi)
    this.tenMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.tenPetNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.tenBakeBLP = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.aeth = new this.web3.eth.Contract(ERC20Abi)
    this.wSOTE = new this.web3.eth.Contract(ERC20Abi)
    this.wSOTEMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.wSoteBakeBLP = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.SHIELD = new this.web3.eth.Contract(ERC20Abi)
    this.SHIELDMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.BRY = new this.web3.eth.Contract(ERC20Abi)
    this.BRYMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.BRYBakeBLP = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.ankr = new this.web3.eth.Contract(ERC20Abi)
    this.onx = new this.web3.eth.Contract(ERC20Abi)
    this.aethMaster = new this.web3.eth.Contract(BakeBaseMaster)
    this.busdToken = new this.web3.eth.Contract(ERC20Abi)
    this.usdtToken = new this.web3.eth.Contract(ERC20Abi)
    this.DEFI100 = new this.web3.eth.Contract(ERC20Abi)
    this.DEFI100Master = new this.web3.eth.Contract(CommonMasterAbi)
    this.DEFI100OLDMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.DEFI100BakeBLP = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bakeryArtwork3NFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeBakeryArtwork3NFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBakeryArtwork3NFT = new this.web3.eth.Contract(BidNFTAbi)
    this.BANANA = new this.web3.eth.Contract(ERC20Abi)
    this.BANANAMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.bakeBananaBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.seascapeNFT = new this.web3.eth.Contract(ERC721Abi)
    this.seascapeCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.exchangeSeascapeNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidSeascapeNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.pCWSBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.pCWSBakeBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.pCWS = new this.web3.eth.Contract(ERC20Abi)
    this.pCWSMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.spartanBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.war = new this.web3.eth.Contract(ERC20Abi)
    this.bakeWarBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.warMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.voteForNFT = new this.web3.eth.Contract(VoteForNFTAbi)
    this.warMaster2 = new this.web3.eth.Contract(CommonMasterAbi)
    this.tokocryptoNft = new this.web3.eth.Contract(ERC721Abi)
    this.tokocryptoCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.exchangeTokocryptoNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidTokocryptoNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.dieselMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.diesel = new this.web3.eth.Contract(ERC20Abi)
    this.crudeoilBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.oneInchBakeNFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeOneInchBakeNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidOneInchBakeNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.mx = new this.web3.eth.Contract(ERC20Abi)
    this.bakeMxBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.mxMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.alice = new this.web3.eth.Contract(ERC20Abi)
    this.bakeAliceBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.aliceMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.aliceNft = new this.web3.eth.Contract(ERC721Abi)
    this.aliceCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.autoBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.soccerBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.soccer = new this.web3.eth.Contract(ERC20Abi)
    this.soccerBakeBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.soccerBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bakerySoccer = new this.web3.eth.Contract(ERC721Abi)
    this.bakerySoccerMaster = new this.web3.eth.Contract(BakerySoccerMasterAbi)
    this.exchangeBakerySoccer = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBakerySoccer = new this.web3.eth.Contract(BidNFTAbi)
    this.bakerySoccerStakingPowerToken = new this.web3.eth.Contract(ERC20Abi)
    this.tct = new this.web3.eth.Contract(ERC20Abi)
    this.tctBusdBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tctMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.dfyMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.gamyfiBakeBaseIdo = new this.web3.eth.Contract(BakeBaseIDO)
    this.gfxMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.xDittoBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.xDittoMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.xDitto = new this.web3.eth.Contract(ERC20Abi)
    this.sactBakeBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.sactMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.pet3Master = new this.web3.eth.Contract(CommonMasterAbi)
    this.hyFiBakeBaseIdo = new this.web3.eth.Contract(BakeBaseIDO)
    this.hyfiMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.tkoCommonStakeERC721EarnERC20 = new this.web3.eth.Contract(CommonStakeERC721EarnERC20Abi)
    this.tkoMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.tkoBakeBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tko = new this.web3.eth.Contract(ERC20Abi)
    this.sfp = new this.web3.eth.Contract(ERC20Abi)
    this.sfpNFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeSfpNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidSfpNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.oneInch = new this.web3.eth.Contract(ERC20Abi)
    this.oneInchBakeCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.tkoMaster2 = new this.web3.eth.Contract(CommonMasterAbi)
    this.tsa = new this.web3.eth.Contract(ERC20Abi)
    this.tsaBakeBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tsaMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.tlm = new this.web3.eth.Contract(ERC20Abi)
    this.tlmBakeBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tlmMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.dittoNft = new this.web3.eth.Contract(ERC721Abi)
    this.dittoCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.poker = new this.web3.eth.Contract(ERC20Abi)
    this.pokerBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.pokerBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.pokerBlindBox = new this.web3.eth.Contract(PokerBlindBoxAbi)
    this.pokerCard = new this.web3.eth.Contract(PokerCardAbi)
    this.pokerCardStakingPowerToken = new this.web3.eth.Contract(ERC20Abi)
    this.pokerCardMaster = new this.web3.eth.Contract(PokerCardMasterAbi)
    this.petBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tlmBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.aliceBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.soccerPokerGameBox = new this.web3.eth.Contract(SoccerPokerGameBoxAbi)
    this.soccerPokerGameBoxBurnByProxy = new this.web3.eth.Contract(SoccerPokerGameBoxBurnByProxyAbi)
    this.soccerPokerGameBoxMaster = new this.web3.eth.Contract(CommonStakeERC721EarnERC20Abi)
    this.carBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.carNFT = new this.web3.eth.Contract(CarNFTAbi)
    this.carNFTStakingPowerToken = new this.web3.eth.Contract(ERC20Abi)
    this.carNFTMaster = new this.web3.eth.Contract(CarNFTMasterAbi)
    this.carBlindBox = new this.web3.eth.Contract(CarBlindBoxAbi)
    this.car = new this.web3.eth.Contract(ERC20Abi)
    this.carBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.exchangeCarNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidCarNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.doggy = new this.web3.eth.Contract(ERC20Abi)
    this.doggyBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.doggyBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.doggyTlmMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.doggyNFT = new this.web3.eth.Contract(DoggyNFTAbi)
    this.doggyNFTCommonStakeERC721EarnBake = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.exchangeDoggyNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidDoggyNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.bondly = new this.web3.eth.Contract(ERC20Abi)
    this.bondlyBnbBLp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bondlyMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.bondlyNft = new this.web3.eth.Contract(ERC721Abi)
    this.bondlyCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.exchangeBondlyNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBondlyNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.doggyBondlyMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.ginu = new this.web3.eth.Contract(ERC20Abi)
    this.ginuBnbBLp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.ginuMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.loveNFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeLoveNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidLoveNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.bark = new this.web3.eth.Contract(ERC20Abi)
    this.barkDoggyBLp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.barkBnbBLp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.barkTlmMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.barkingNFT = new this.web3.eth.Contract(BarkingNFTAbi)
    this.barkingNFTCommonStakeERC721EarnBake = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.exchangeBarkingNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidBarkingNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.raca = new this.web3.eth.Contract(ERC20Abi)
    this.racaNFT = new this.web3.eth.Contract(BakeryArtworkNftAbi)
    this.exchangeRacaNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidRacaNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.yooshiNFT = new this.web3.eth.Contract(ERC721Abi)
    this.exchangeYooshiNFT = new this.web3.eth.Contract(ExchangeNFTAbi)
    this.bidYooshiNFT = new this.web3.eth.Contract(BidNFTAbi)
    this.bscBakeNFT = new this.web3.eth.Contract(CreatorRoyaltiesNFTAbi)
    this.bidBscBakeNFT = new this.web3.eth.Contract(BidNFTV2Abi)
    this.exchangeBscBakeNFT = new this.web3.eth.Contract(ExchangeNFTV2Abi)
    this.tokauBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.tokau = new this.web3.eth.Contract(ERC20Abi)
    this.tokauBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tokauTlmBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.tokauTlmMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.xmsBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.doge = new this.web3.eth.Contract(ERC20Abi)
    this.exchangeNFTs = new this.web3.eth.Contract(ExchangeNFTsAbi)
    this.tokauNFT = new this.web3.eth.Contract(ERC721Abi)
    this.doggyEquipment = new this.web3.eth.Contract(DoggyEquipmentAbi)
    this.doggyEquipmentCommonStakeERC721EarnBake = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.matrixPlusBox = new this.web3.eth.Contract(MatrixPlusBoxAbi)
    this.matrixPlusBoxCommonStakeERC721EarnBake = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.gat = new this.web3.eth.Contract(ERC20Abi)
    this.toys = new this.web3.eth.Contract(ERC721Abi)
    this.simpleStakeToysEarnGat = new this.web3.eth.Contract(SimpleStakeERC721EarnERC20Abi)
    this.lev = new this.web3.eth.Contract(ERC20Abi)
    this.siBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.liBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.levBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.levMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.gatBakeBaseIDO = new this.web3.eth.Contract(BakeBaseIDO)
    this.gatBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.gatTlmMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.ktaNFT = new this.web3.eth.Contract(ERC721Abi)
    this.masterChef2 = new this.web3.eth.Contract(CommonMasterAbi)
    this.wsg = new this.web3.eth.Contract(ERC20Abi)
    this.wsgBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.wsgMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.toysCommonNftMaster = new this.web3.eth.Contract(CommonNftMasterAbi)
    this.bethMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.tokauMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.bakeMuskMixer = new this.web3.eth.Contract(BakeMuskMixerAbi)
    this.bakeMuskMixerCommonStakeERC721EarnBake = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.usdtBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bakeBusdBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.busdBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bakerySoccerCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.doggyNFTCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.barkingNFTCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.doggyEquipmentCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.bakeMuskMixerCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.pokerCardCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.comboNFTCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.carNFTCommonStakeERC721EarnBake2 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.exchangeNFTs2 = new this.web3.eth.Contract(ExchangeNFTsAbi)
    this.muskUsmLand = new this.web3.eth.Contract(MuskUsmLandAbi)
    this.carNFTCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.comboNFTCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.pokerCardCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.bakeMuskMixerCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.doggyEquipmentCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.barkingNFTCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.doggyNFTCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.bakerySoccerCommonStakeERC721EarnBake3 = new this.web3.eth.Contract(CommonStakeERC721EarnBakeAbi)
    this.newDonghuangArt = new this.web3.eth.Contract(NewDonghuangArtAbi)
    this.bnrg = new this.web3.eth.Contract(ERC20Abi)
    this.bmon = new this.web3.eth.Contract(ERC20Abi)
    this.bmonBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bmonBusdBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.bnrgBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.earnBnrgMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.stakeBmoncEarnBmon = new this.web3.eth.Contract(CommonStakeERC721EarnERC20Abi)
    this.bmonc = new this.web3.eth.Contract(ERC721Abi)
    this.ga = new this.web3.eth.Contract(ERC721Abi)
    this.sellNFTs = new this.web3.eth.Contract(SellNFTsAbi)
    this.bmoncNFT = new this.web3.eth.Contract(BmoncNFTAbi)
    this.dogo = new this.web3.eth.Contract(ERC20Abi)
    this.dogoMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.dogoBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.egg = new this.web3.eth.Contract(ERC20Abi)
    this.eggMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.eggBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.kalata = new this.web3.eth.Contract(ERC20Abi)
    this.kalataMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.kalataBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.don = new this.web3.eth.Contract(ERC20Abi)
    this.donMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.donBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.kTreasureAdvanced = new this.web3.eth.Contract(ERC721Abi)
    this.kRabbit = new this.web3.eth.Contract(ERC721Abi)
    this.nt = new this.web3.eth.Contract(ERC20Abi)
    this.ntMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.ntBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.kmoNFT = new this.web3.eth.Contract(ERC721Abi)
    this.moni = new this.web3.eth.Contract(ERC20Abi)
    this.moniMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.moniBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.kxa = new this.web3.eth.Contract(ERC20Abi)
    this.kxaMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.kxaBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)
    this.nbl = new this.web3.eth.Contract(ERC20Abi)
    this.earnNblMaster = new this.web3.eth.Contract(CommonMasterAbi)
    this.nblBnbBlp = new this.web3.eth.Contract(BakerySwapPairAbi)

    this.pools = supportedPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.poolsV2 = supportedV2Pools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    // mint pet pools
    this.petPools = supportedPetPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    // mint pet & bake pools
    this.newPools = supportedNewPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bakeStakingPools = supportedBakeStakingPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.DEFI100MasterPools = DEFI100MasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.DEFI100OLDMasterPools = DEFI100OLDMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )
    this.endedPools = endedPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.otherPools = otherPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.allNftPools = allNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bPetPools = bPetPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )
    this.weaponPools = weaponPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bestPools = bestPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.weaponnftPools = weaponnftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.petNftPools = petNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.helmetNftPools = helmetNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.eth2MasterPools = eth2MasterPools.map(pool => {
      pool = Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi)
      })
      pool.tokenAddresses = pool.tokenAddresses.map(tokenInfo =>
        Object.assign(tokenInfo, {
          tokenAddress: tokenInfo[networkId],
          tokenContract: new this.web3.eth.Contract(ERC20Abi)
        })
      )
      return pool
    })

    this.aethMasterPools = aethMasterPools.map(pool => {
      pool = Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi)
      })
      pool.tokenAddresses = pool.tokenAddresses.map(tokenInfo =>
        Object.assign(tokenInfo, {
          tokenAddress: tokenInfo[networkId],
          tokenContract: new this.web3.eth.Contract(ERC20Abi)
        })
      )
      return pool
    })

    this.aethAndEth2Pools = aethAndEth2Pools.map(pool => {
      pool = Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi)
      })
      pool.tokenAddresses = pool.tokenAddresses.map(tokenInfo =>
        Object.assign(tokenInfo, {
          tokenAddress: tokenInfo[networkId],
          tokenContract: new this.web3.eth.Contract(ERC20Abi)
        })
      )
      return pool
    })

    this.springMasterPools = springMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.wSOTEMasterPools = wSOTEMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.SHIELDMasterPools = SHIELDMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.BRYMasterPools = BRYMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.BananaMasterPools = BananaMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.seascapeNftPools = seascapeNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.pCWSMasterPools = pCWSMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.warMasterPools = warMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.war2MasterPools = war2MasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.hatNftPools = hatNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tokocryptoNftPools = tokocryptoNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.dieselMasterPools = dieselPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.mxMasterPools = mxMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.aliceMasterPools = aliceMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.aliceNftPools = aliceNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bondlyNftPools = bondlyNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tctMasterPools = tctMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.dfyMasterPools = dfyMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.gfxMasterPools = gfxMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.xDittoMasterPools = xDittoMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.sactMasterPools = sactMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.pet3Pools = pet3Pools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.hyfiPools = hyfiPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.ginuPools = ginuPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.levPools = levPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bondlyPools = bondlyPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bondly2Pools = bondly2Pools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tkoPools = tkoPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tkoNftPools = tkoNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bakeMuskMixerNftPools = bakeMuskMixerNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.toyNftPools = toyNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bmoncNftPools = bmoncNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.nftStakingPools = nftStakingPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.oneInchBakeNftPools = oneInchBakeNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tko2Pools = tko2Pools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bnrgPools = bnrgPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tsaPools = tsaPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tlmPools = tlmPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.xdittoNftPools = xdittoNftPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.doggyTlmPools = doggyTlmPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.barkTlmPools = barkTlmPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tokauTlmPools = tokauTlmPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.gatTlmPools = gatTlmPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.wsgPools = wsgPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.dogoPools = dogoPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.eggPools = eggPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.kalataPools = kalataPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.donPools = donPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.toynftEarnPools = toynftEarnPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.bethMasterPools = bethMasterPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.tokauPools = tokauPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.ntPools = ntPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.moniPools = moniPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.kxaPools = kxaPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.nblPools = nblPools.map(pool =>
      Object.assign(pool, {
        lpAddress: pool.lpAddresses[networkId],
        tokenAddress: pool.tokenAddresses[networkId],
        lpContract: new this.web3.eth.Contract(BakerySwapPairAbi),
        tokenContract: new this.web3.eth.Contract(ERC20Abi)
      })
    )

    this.setProvider(provider, networkId)
    this.setDefaultAccount(this.web3.eth.defaultAccount)
  }

  setProvider(provider, networkId) {
    const setProvider = (contract, address) => {
      contract.setProvider(provider)
      // console.log("---address---",address)
      // console.log("---contract.options.address---",contract.options.address)
      if (address) contract.options.address = address
      else console.error('Contract address not found in network', contract, networkId)
    }

    setProvider(this.sushi, contractAddresses.sushi[networkId])
    setProvider(this.masterChef, contractAddresses.masterChef[networkId])
    setProvider(this.weth, contractAddresses.weth[networkId])
    setProvider(this.dish, contractAddresses.dish[networkId])
    setProvider(this.bakeBnbBlp, contractAddresses.bakeBnbBlp[networkId])
    setProvider(this.nftHelper, contractAddresses.nftHelper[networkId])
    setProvider(this.dishMaster, contractAddresses.dishMaster[networkId])
    setProvider(this.exchangeNFT, contractAddresses.exchangeNFT[networkId])
    setProvider(this.bidDishNFT, contractAddresses.bidDishNFT[networkId])
    setProvider(this.pet, contractAddresses.pet[networkId])
    setProvider(this.petMaster, contractAddresses.petMaster[networkId])
    setProvider(this.petMaster2, contractAddresses.petMaster2[networkId])
    setProvider(this.petEggNft, contractAddresses.petEggNft[networkId])
    setProvider(this.exchangeEggNFT, contractAddresses.exchangeEggNFT[networkId])
    setProvider(this.bidPetEggNFT, contractAddresses.bidPetEggNFT[networkId])
    setProvider(this.digitalArtworkNft, contractAddresses.digitalArtworkNft[networkId])
    setProvider(this.exchangeArtworkNFT, contractAddresses.exchangeArtworkNFT[networkId])
    setProvider(this.bidDigitalArtworkNFT, contractAddresses.bidDigitalArtworkNFT[networkId])
    setProvider(this.weapon, contractAddresses.weapon[networkId])
    setProvider(this.weaponBnbBlp, contractAddresses.weaponBnbBlp[networkId])
    setProvider(this.weaponNFT, contractAddresses.weaponNFT[networkId])
    setProvider(this.weaponMaster, contractAddresses.weaponMaster[networkId])
    setProvider(this.exchangeWeaponNFT, contractAddresses.exchangeWeaponNFT[networkId])
    setProvider(this.bidWeaponNFT, contractAddresses.bidWeaponNFT[networkId])
    setProvider(this.binanceNft, contractAddresses.binanceNft[networkId])
    setProvider(this.exchangeBinanceNft, contractAddresses.exchangeBinanceNft[networkId])
    setProvider(this.bidBinanceNFT, contractAddresses.bidBinanceNFT[networkId])
    setProvider(this.bestToken, contractAddresses.bestToken[networkId])
    setProvider(this.bestMaster, contractAddresses.bestMaster[networkId])
    setProvider(this.bakeryArtworkNFT, contractAddresses.bakeryArtworkNFT[networkId])
    setProvider(this.exchangeBakeryArtworkNFT, contractAddresses.exchangeBakeryArtworkNFT[networkId])
    setProvider(this.bidBakeryArtworkNFT, contractAddresses.bidBakeryArtworkNFT[networkId])
    setProvider(this.bakeryArtworkRouter, contractAddresses.bakeryArtworkRouter[networkId])
    setProvider(this.weaponNFTCommonMaster, contractAddresses.weaponNFTCommonMaster[networkId])
    setProvider(this.petNFTCommonMaster, contractAddresses.petNFTCommonMaster[networkId])
    setProvider(this.helmetNft, contractAddresses.helmetNft[networkId])
    setProvider(this.helmetNftCommonMaster, contractAddresses.helmetNftCommonMaster[networkId])
    setProvider(this.bethBakeBLP, contractAddresses.bethBakeBLP[networkId])
    setProvider(this.beth, contractAddresses.beth[networkId])
    setProvider(this.ten, contractAddresses.ten[networkId])
    setProvider(this.tenMaster, contractAddresses.tenMaster[networkId])
    setProvider(this.tenPetNftMaster, contractAddresses.tenPetNftMaster[networkId])
    setProvider(this.tenBakeBLP, contractAddresses.tenBakeBLP[networkId])
    setProvider(this.wSOTE, contractAddresses.wSOTE[networkId])
    setProvider(this.wSOTEMaster, contractAddresses.wSOTEMaster[networkId])
    setProvider(this.wSoteBakeBLP, contractAddresses.wSoteBakeBLP[networkId])
    setProvider(this.SHIELD, contractAddresses.SHIELD[networkId])
    setProvider(this.SHIELDMaster, contractAddresses.SHIELDMaster[networkId])
    setProvider(this.BRY, contractAddresses.BRY[networkId])
    setProvider(this.BRYMaster, contractAddresses.BRYMaster[networkId])
    setProvider(this.BRYBakeBLP, contractAddresses.BRYBakeBLP[networkId])
    setProvider(this.DEFI100, contractAddresses.DEFI100[networkId])
    setProvider(this.DEFI100Master, contractAddresses.DEFI100Master[networkId])
    setProvider(this.DEFI100OLDMaster, contractAddresses.DEFI100OldMaster[networkId])
    setProvider(this.DEFI100BakeBLP, contractAddresses.DEFI100BakeBLP[networkId])
    setProvider(this.BANANA, contractAddresses.BANANA[networkId])
    setProvider(this.BANANAMaster, contractAddresses.BANANAMaster[networkId])
    setProvider(this.bakeBananaBlp, contractAddresses.bakeBananaBlp[networkId])
    setProvider(this.petNft, contractAddresses.petNft[networkId])
    setProvider(this.exchangePetNft, contractAddresses.exchangePetNft[networkId])
    setProvider(this.bidPetNFT, contractAddresses.bidPetNFT[networkId])
    setProvider(this.bakeryArtwork2NFT, contractAddresses.bakeryArtwork2NFT[networkId])
    setProvider(this.exchangeBakeryArtwork2NFT, contractAddresses.exchangeBakeryArtwork2NFT[networkId])
    setProvider(this.bidBakeryArtwork2NFT, contractAddresses.bidBakeryArtwork2NFT[networkId])
    setProvider(this.dogeMemeNFT, contractAddresses.dogeMemeNFT[networkId])
    setProvider(this.exchangeDogeMemeNFT, contractAddresses.exchangeDogeMemeNFT[networkId])
    setProvider(this.bidDogeMemeNFT, contractAddresses.bidDogeMemeNFT[networkId])
    setProvider(this.eth2Master, contractAddresses.eth2Master[networkId])
    setProvider(this.busdToken, contractAddresses.busdToken[networkId])
    setProvider(this.usdtToken, contractAddresses.usdtToken[networkId])
    setProvider(this.bakeryArtwork3NFT, contractAddresses.bakeryArtwork3NFT[networkId])
    setProvider(this.exchangeBakeryArtwork3NFT, contractAddresses.exchangeBakeryArtwork3NFT[networkId])
    setProvider(this.bidBakeryArtwork3NFT, contractAddresses.bidBakeryArtwork3NFT[networkId])
    setProvider(this.spartanBakeBaseIDO, contractAddresses.spartanBakeBaseIDO[networkId])
    setProvider(this.crudeoilBakeBaseIDO, contractAddresses.crudeoilBakeBaseIDO[networkId])
    setProvider(this.soccerBakeBaseIDO, contractAddresses.soccerBakeBaseIDO[networkId])
    setProvider(this.aeth, contractAddresses.aeth[networkId])
    setProvider(this.ankr, contractAddresses.ankr[networkId])
    setProvider(this.onx, contractAddresses.onx[networkId])
    setProvider(this.aethMaster, contractAddresses.aethMaster[networkId])
    setProvider(this.seascapeNFT, contractAddresses.seascapeNFT[networkId])
    setProvider(this.seascapeCommonNftMaster, contractAddresses.seascapeCommonNftMaster[networkId])
    setProvider(this.exchangeSeascapeNFT, contractAddresses.exchangeSeascapeNFT[networkId])
    setProvider(this.bidSeascapeNFT, contractAddresses.bidSeascapeNFT[networkId])
    setProvider(this.pCWSBnbBlp, contractAddresses.pCWSBnbBlp[networkId])
    setProvider(this.pCWSBakeBlp, contractAddresses.pCWSBakeBlp[networkId])
    setProvider(this.pCWS, contractAddresses.pCWS[networkId])
    setProvider(this.pCWSMaster, contractAddresses.pCWSMaster[networkId])
    setProvider(this.war, contractAddresses.war[networkId])
    setProvider(this.bakeWarBlp, contractAddresses.bakeWarBlp[networkId])
    setProvider(this.warMaster, contractAddresses.warMaster[networkId])
    setProvider(this.voteForNFT, contractAddresses.voteForNFT[networkId])
    setProvider(this.warMaster2, contractAddresses.warMaster2[networkId])
    setProvider(this.tokocryptoNft, contractAddresses.tokocryptoNft[networkId])
    setProvider(this.tokocryptoCommonNftMaster, contractAddresses.tokocryptoCommonNftMaster[networkId])
    setProvider(this.exchangeTokocryptoNFT, contractAddresses.exchangeTokocryptoNFT[networkId])
    setProvider(this.bidTokocryptoNFT, contractAddresses.bidTokocryptoNFT[networkId])
    setProvider(this.dieselMaster, contractAddresses.dieselMaster[networkId])
    setProvider(this.diesel, contractAddresses.diesel[networkId])
    setProvider(this.oneInchBakeNFT, contractAddresses.oneInchBakeNFT[networkId])
    setProvider(this.exchangeOneInchBakeNFT, contractAddresses.exchangeOneInchBakeNFT[networkId])
    setProvider(this.bidOneInchBakeNFT, contractAddresses.bidOneInchBakeNFT[networkId])
    setProvider(this.mx, contractAddresses.mx[networkId])
    setProvider(this.bakeMxBlp, contractAddresses.bakeMxBlp[networkId])
    setProvider(this.mxMaster, contractAddresses.mxMaster[networkId])
    setProvider(this.alice, contractAddresses.alice[networkId])
    setProvider(this.aliceMaster, contractAddresses.aliceMaster[networkId])
    setProvider(this.bakeAliceBlp, contractAddresses.bakeAliceBlp[networkId])
    setProvider(this.aliceNft, contractAddresses.aliceNft[networkId])
    setProvider(this.aliceCommonNftMaster, contractAddresses.aliceCommonNftMaster[networkId])
    setProvider(this.autoBnbBlp, contractAddresses.autoBnbBlp[networkId])
    setProvider(this.soccer, contractAddresses.soccer[networkId])
    setProvider(this.soccerBakeBlp, contractAddresses.soccerBakeBlp[networkId])
    setProvider(this.soccerBnbBlp, contractAddresses.soccerBnbBlp[networkId])
    setProvider(this.bakerySoccer, contractAddresses.bakerySoccer[networkId])
    setProvider(this.bakerySoccerMaster, contractAddresses.bakerySoccerMaster[networkId])
    setProvider(this.exchangeBakerySoccer, contractAddresses.exchangeBakerySoccer[networkId])
    setProvider(this.bidBakerySoccer, contractAddresses.bidBakerySoccer[networkId])
    setProvider(this.bakerySoccerStakingPowerToken, contractAddresses.bakerySoccerStakingPowerToken[networkId])
    setProvider(this.tct, contractAddresses.tct[networkId])
    setProvider(this.tctBusdBlp, contractAddresses.tctBusdBlp[networkId])
    setProvider(this.tctMaster, contractAddresses.tctMaster[networkId])
    setProvider(this.dfyMaster, contractAddresses.dfyMaster[networkId])
    setProvider(this.gamyfiBakeBaseIdo, contractAddresses.gamyfiBakeBaseIdo[networkId])
    setProvider(this.gfxMaster, contractAddresses.gfxMaster[networkId])
    setProvider(this.xDittoMaster, contractAddresses.xDittoMaster[networkId])
    setProvider(this.xDittoBnbBlp, contractAddresses.xDittoBnbBlp[networkId])
    setProvider(this.xDitto, contractAddresses.xDitto[networkId])
    setProvider(this.sactBakeBlp, contractAddresses.sactBakeBlp[networkId])
    setProvider(this.sactMaster, contractAddresses.sactMaster[networkId])
    setProvider(this.pet3Master, contractAddresses.pet3Master[networkId])
    setProvider(this.hyFiBakeBaseIdo, contractAddresses.hyFiBakeBaseIdo[networkId])
    setProvider(this.hyfiMaster, contractAddresses.hyfiMaster[networkId])
    setProvider(this.tkoMaster, contractAddresses.tkoMaster[networkId])
    setProvider(this.tkoBakeBlp, contractAddresses.tkoBakeBlp[networkId])
    setProvider(this.tko, contractAddresses.tko[networkId])
    setProvider(this.tkoCommonStakeERC721EarnERC20, contractAddresses.tkoCommonStakeERC721EarnERC20[networkId])
    setProvider(this.sfp, contractAddresses.sfp[networkId])
    setProvider(this.sfpNFT, contractAddresses.sfpNFT[networkId])
    setProvider(this.exchangeSfpNFT, contractAddresses.exchangeSfpNFT[networkId])
    setProvider(this.bidSfpNFT, contractAddresses.bidSfpNFT[networkId])
    setProvider(this.oneInch, contractAddresses.oneInch[networkId])
    setProvider(this.oneInchBakeCommonNftMaster, contractAddresses.oneInchBakeCommonNftMaster[networkId])
    setProvider(this.tkoMaster2, contractAddresses.tkoMaster2[networkId])
    setProvider(this.tsa, contractAddresses.tsa[networkId])
    setProvider(this.tsaMaster, contractAddresses.tsaMaster[networkId])
    setProvider(this.tsaBakeBlp, contractAddresses.tsaBakeBlp[networkId])
    setProvider(this.tlm, contractAddresses.tlm[networkId])
    setProvider(this.tlmMaster, contractAddresses.tlmMaster[networkId])
    setProvider(this.tlmBakeBlp, contractAddresses.tlmBakeBlp[networkId])
    setProvider(this.dittoNft, contractAddresses.dittoNft[networkId])
    setProvider(this.dittoCommonNftMaster, contractAddresses.dittoCommonNftMaster[networkId])
    setProvider(this.poker, contractAddresses.poker[networkId])
    setProvider(this.pokerBnbBlp, contractAddresses.pokerBnbBlp[networkId])
    setProvider(this.pokerBakeBaseIDO, contractAddresses.pokerBakeBaseIDO[networkId])
    setProvider(this.pokerBlindBox, contractAddresses.pokerBlindBox[networkId])
    setProvider(this.pokerCard, contractAddresses.pokerCard[networkId])
    setProvider(this.pokerCardStakingPowerToken, contractAddresses.pokerCardStakingPowerToken[networkId])
    setProvider(this.pokerCardMaster, contractAddresses.pokerCardMaster[networkId])
    setProvider(this.petBnbBlp, contractAddresses.petBnbBlp[networkId])
    setProvider(this.tlmBnbBlp, contractAddresses.tlmBnbBlp[networkId])
    setProvider(this.aliceBnbBlp, contractAddresses.aliceBnbBlp[networkId])
    setProvider(this.soccerPokerGameBox, contractAddresses.soccerPokerGameBox[networkId])
    setProvider(this.soccerPokerGameBoxBurnByProxy, contractAddresses.soccerPokerGameBoxBurnByProxy[networkId])
    setProvider(this.soccerPokerGameBoxMaster, contractAddresses.soccerPokerGameBoxMaster[networkId])
    setProvider(this.carBakeBaseIDO, contractAddresses.carBakeBaseIDO[networkId])
    setProvider(this.carNFT, contractAddresses.carNFT[networkId])
    setProvider(this.carNFTStakingPowerToken, contractAddresses.carNFTStakingPowerToken[networkId])
    setProvider(this.carNFTMaster, contractAddresses.carNFTMaster[networkId])
    setProvider(this.carBlindBox, contractAddresses.carBlindBox[networkId])
    setProvider(this.car, contractAddresses.car[networkId])
    setProvider(this.carBnbBlp, contractAddresses.carBnbBlp[networkId])
    setProvider(this.exchangeCarNFT, contractAddresses.exchangeCarNFT[networkId])
    setProvider(this.bidCarNFT, contractAddresses.bidCarNFT[networkId])
    setProvider(this.doggy, contractAddresses.doggy[networkId])
    setProvider(this.doggyBnbBlp, contractAddresses.doggyBnbBlp[networkId])
    setProvider(this.doggyBakeBaseIDO, contractAddresses.doggyBakeBaseIDO[networkId])
    setProvider(this.doggyTlmMaster, contractAddresses.doggyTlmMaster[networkId])
    setProvider(this.doggyNFT, contractAddresses.doggyNFT[networkId])
    setProvider(this.doggyNFTCommonStakeERC721EarnBake, contractAddresses.doggyNFTCommonStakeERC721EarnBake[networkId])
    setProvider(this.exchangeDoggyNFT, contractAddresses.exchangeDoggyNFT[networkId])
    setProvider(this.bidDoggyNFT, contractAddresses.bidDoggyNFT[networkId])
    setProvider(this.bondly, contractAddresses.bondly[networkId])
    setProvider(this.bondlyBnbBLp, contractAddresses.bondlyBnbBLp[networkId])
    setProvider(this.bondlyMaster, contractAddresses.bondlyMaster[networkId])
    setProvider(this.bondlyNft, contractAddresses.bondlyNft[networkId])
    setProvider(this.bondlyCommonNftMaster, contractAddresses.bondlyCommonNftMaster[networkId])
    setProvider(this.exchangeBondlyNFT, contractAddresses.exchangeBondlyNFT[networkId])
    setProvider(this.bidBondlyNFT, contractAddresses.bidBondlyNFT[networkId])
    setProvider(this.doggyBondlyMaster, contractAddresses.doggyBondlyMaster[networkId])
    setProvider(this.ginu, contractAddresses.ginu[networkId])
    setProvider(this.ginuBnbBLp, contractAddresses.ginuBnbBLp[networkId])
    setProvider(this.ginuMaster, contractAddresses.ginuMaster[networkId])
    setProvider(this.loveNFT, contractAddresses.loveNFT[networkId])
    setProvider(this.exchangeLoveNFT, contractAddresses.exchangeLoveNFT[networkId])
    setProvider(this.bidLoveNFT, contractAddresses.bidLoveNFT[networkId])
    setProvider(this.bark, contractAddresses.bark[networkId])
    setProvider(this.barkDoggyBLp, contractAddresses.barkDoggyBLp[networkId])
    setProvider(this.barkBnbBLp, contractAddresses.barkBnbBLp[networkId])
    setProvider(this.barkTlmMaster, contractAddresses.barkTlmMaster[networkId])
    setProvider(this.barkingNFT, contractAddresses.barkingNFT[networkId])
    setProvider(
      this.barkingNFTCommonStakeERC721EarnBake,
      contractAddresses.barkingNFTCommonStakeERC721EarnBake[networkId]
    )
    setProvider(this.bidBarkingNFT, contractAddresses.bidBarkingNFT[networkId])
    setProvider(this.exchangeBarkingNFT, contractAddresses.exchangeBarkingNFT[networkId])
    setProvider(this.yooshiNFT, contractAddresses.yooshiNFT[networkId])
    setProvider(this.exchangeYooshiNFT, contractAddresses.exchangeYooshiNFT[networkId])
    setProvider(this.bidYooshiNFT, contractAddresses.bidYooshiNFT[networkId])
    setProvider(this.raca, contractAddresses.raca[networkId])
    setProvider(this.racaNFT, contractAddresses.racaNFT[networkId])
    setProvider(this.exchangeRacaNFT, contractAddresses.exchangeRacaNFT[networkId])
    setProvider(this.bidRacaNFT, contractAddresses.bidRacaNFT[networkId])
    setProvider(this.bscBakeNFT, contractAddresses.bscBakeNFT[networkId])
    setProvider(this.exchangeBscBakeNFT, contractAddresses.exchangeBscBakeNFT[networkId])
    setProvider(this.bidBscBakeNFT, contractAddresses.bidBscBakeNFT[networkId])
    setProvider(this.tokauBakeBaseIDO, contractAddresses.tokauBakeBaseIDO[networkId])
    setProvider(this.tokau, contractAddresses.tokau[networkId])
    setProvider(this.tokauBnbBlp, contractAddresses.tokauBnbBlp[networkId])
    setProvider(this.tokauTlmBlp, contractAddresses.tokauTlmBlp[networkId])
    setProvider(this.tokauTlmMaster, contractAddresses.tokauTlmMaster[networkId])
    setProvider(this.xmsBakeBaseIDO, contractAddresses.xmsBakeBaseIDO[networkId])
    setProvider(this.doge, contractAddresses.doge[networkId])
    setProvider(this.exchangeNFTs, contractAddresses.exchangeNFTs[networkId])
    setProvider(this.tokauNFT, contractAddresses.tokauNFT[networkId])
    setProvider(this.doggyEquipment, contractAddresses.doggyEquipment[networkId])
    setProvider(
      this.doggyEquipmentCommonStakeERC721EarnBake,
      contractAddresses.doggyEquipmentCommonStakeERC721EarnBake[networkId]
    )
    setProvider(this.matrixPlusBox, contractAddresses.matrixPlusBox[networkId])
    setProvider(
      this.matrixPlusBoxCommonStakeERC721EarnBake,
      contractAddresses.matrixPlusBoxCommonStakeERC721EarnBake[networkId]
    )
    setProvider(this.toys, contractAddresses.toys[networkId])
    setProvider(this.gat, contractAddresses.gat[networkId])
    setProvider(this.simpleStakeToysEarnGat, contractAddresses.simpleStakeToysEarnGat[networkId])
    setProvider(this.lev, contractAddresses.lev[networkId])
    setProvider(this.siBnbBlp, contractAddresses.siBnbBlp[networkId])
    setProvider(this.liBnbBlp, contractAddresses.liBnbBlp[networkId])
    setProvider(this.levBnbBlp, contractAddresses.levBnbBlp[networkId])
    setProvider(this.levMaster, contractAddresses.levMaster[networkId])
    setProvider(this.gatBnbBlp, contractAddresses.gatBnbBlp[networkId])
    setProvider(this.gatBakeBaseIDO, contractAddresses.gatBakeBaseIDO[networkId])
    setProvider(this.gatTlmMaster, contractAddresses.gatTlmMaster[networkId])
    setProvider(this.ktaNFT, contractAddresses.ktaNFT[networkId])
    setProvider(this.masterChef2, contractAddresses.masterChef2[networkId])
    setProvider(this.wsg, contractAddresses.wsg[networkId])
    setProvider(this.wsgBnbBlp, contractAddresses.wsgBnbBlp[networkId])
    setProvider(this.wsgMaster, contractAddresses.wsgMaster[networkId])
    setProvider(this.toysCommonNftMaster, contractAddresses.toysCommonNftMaster[networkId])
    setProvider(this.bethMaster, contractAddresses.bethMaster[networkId])
    setProvider(this.tokauMaster, contractAddresses.tokauMaster[networkId])
    setProvider(this.bakeMuskMixer, contractAddresses.bakeMuskMixer[networkId])
    setProvider(this.bakeMuskMixerCommonStakeERC721EarnBake, contractAddresses.bakeMuskMixerCommonStakeERC721EarnBake[networkId])
    setProvider(this.usdtBnbBlp, contractAddresses.usdtBnbBlp[networkId])
    setProvider(this.bakeBusdBlp, contractAddresses.bakeBusdBlp[networkId])
    setProvider(this.busdBnbBlp, contractAddresses.busdBnbBlp[networkId])
    setProvider(this.bakerySoccerCommonStakeERC721EarnBake2, contractAddresses.bakerySoccerCommonStakeERC721EarnBake2[networkId])
    setProvider(this.doggyNFTCommonStakeERC721EarnBake2, contractAddresses.doggyNFTCommonStakeERC721EarnBake2[networkId])
    setProvider(
      this.barkingNFTCommonStakeERC721EarnBake2,
      contractAddresses.barkingNFTCommonStakeERC721EarnBake2[networkId]
    )
    setProvider(
      this.doggyEquipmentCommonStakeERC721EarnBake2,
      contractAddresses.doggyEquipmentCommonStakeERC721EarnBake2[networkId]
    )
    setProvider(this.bakeMuskMixerCommonStakeERC721EarnBake2, contractAddresses.bakeMuskMixerCommonStakeERC721EarnBake2[networkId])
    setProvider(this.pokerCardCommonStakeERC721EarnBake2, contractAddresses.pokerCardCommonStakeERC721EarnBake2[networkId])
    setProvider(this.comboNFTCommonStakeERC721EarnBake2, contractAddresses.comboNFTCommonStakeERC721EarnBake2[networkId])
    setProvider(this.carNFTCommonStakeERC721EarnBake2, contractAddresses.carNFTCommonStakeERC721EarnBake2[networkId])
    setProvider(this.exchangeNFTs2, contractAddresses.exchangeNFTs2[networkId])
    setProvider(this.muskUsmLand, contractAddresses.muskUsmLand[networkId])
    setProvider(this.carNFTCommonStakeERC721EarnBake3, contractAddresses.carNFTCommonStakeERC721EarnBake3[networkId])
    setProvider(this.comboNFTCommonStakeERC721EarnBake3, contractAddresses.comboNFTCommonStakeERC721EarnBake3[networkId])
    setProvider(this.pokerCardCommonStakeERC721EarnBake3, contractAddresses.pokerCardCommonStakeERC721EarnBake3[networkId])
    setProvider(this.bakeMuskMixerCommonStakeERC721EarnBake3, contractAddresses.bakeMuskMixerCommonStakeERC721EarnBake3[networkId])
    setProvider(this.doggyEquipmentCommonStakeERC721EarnBake3, contractAddresses.doggyEquipmentCommonStakeERC721EarnBake3[networkId])
    setProvider(this.barkingNFTCommonStakeERC721EarnBake3, contractAddresses.barkingNFTCommonStakeERC721EarnBake3[networkId])
    setProvider(this.doggyNFTCommonStakeERC721EarnBake3, contractAddresses.doggyNFTCommonStakeERC721EarnBake3[networkId])
    setProvider(this.bakerySoccerCommonStakeERC721EarnBake3, contractAddresses.bakerySoccerCommonStakeERC721EarnBake3[networkId])
    setProvider(this.newDonghuangArt, contractAddresses.newDonghuangArt[networkId])
    setProvider(this.bnrg, contractAddresses.bnrg[networkId])
    setProvider(this.bmon, contractAddresses.bmon[networkId])
    setProvider(this.bmonBnbBlp, contractAddresses.bmonBnbBlp[networkId])
    setProvider(this.bmonBusdBlp, contractAddresses.bmonBusdBlp[networkId])
    setProvider(this.earnBnrgMaster, contractAddresses.earnBnrgMaster[networkId])
    setProvider(this.bnrgBnbBlp, contractAddresses.bnrgBnbBlp[networkId])
    setProvider(this.bmonc, contractAddresses.bmonc[networkId])
    setProvider(this.stakeBmoncEarnBmon, contractAddresses.stakeBmoncEarnBmon[networkId])
    setProvider(this.ga, contractAddresses.ga[networkId])
    setProvider(this.sellNFTs, contractAddresses.sellNFTs[networkId])
    setProvider(this.bmoncNFT, contractAddresses.bmoncNFT[networkId])
    setProvider(this.dogo, contractAddresses.dogo[networkId])
    setProvider(this.dogoMaster, contractAddresses.dogoMaster[networkId])
    setProvider(this.dogoBnbBlp, contractAddresses.dogoBnbBlp[networkId])
    setProvider(this.egg, contractAddresses.egg[networkId])
    setProvider(this.eggMaster, contractAddresses.eggMaster[networkId])
    setProvider(this.eggBnbBlp, contractAddresses.eggBnbBlp[networkId])
    setProvider(this.kalata, contractAddresses.kalata[networkId])
    setProvider(this.kalataMaster, contractAddresses.kalataMaster[networkId])
    setProvider(this.kalataBnbBlp, contractAddresses.kalataBnbBlp[networkId])
    setProvider(this.don, contractAddresses.don[networkId])
    setProvider(this.donMaster, contractAddresses.donMaster[networkId])
    setProvider(this.donBnbBlp, contractAddresses.donBnbBlp[networkId])
    setProvider(this.kTreasureAdvanced,contractAddresses.kTreasureAdvanced[networkId])
    setProvider(this.kRabbit, contractAddresses.kRabbit[networkId])
    setProvider(this.nt, contractAddresses.nt[networkId])
    setProvider(this.ntMaster, contractAddresses.ntMaster[networkId])
    setProvider(this.ntBnbBlp, contractAddresses.ntBnbBlp[networkId])
    setProvider(this.kmoNFT, contractAddresses.kmoNFT[networkId])
    setProvider(this.moni, contractAddresses.moni[networkId])
    setProvider(this.moniMaster, contractAddresses.moniMaster[networkId])
    setProvider(this.moniBnbBlp, contractAddresses.moniBnbBlp[networkId])
    setProvider(this.kxa, contractAddresses.kxa[networkId])
    setProvider(this.kxaMaster, contractAddresses.kxaMaster[networkId])
    setProvider(this.kxaBnbBlp, contractAddresses.kxaBnbBlp[networkId])
    setProvider(this.nbl, contractAddresses.nbl[networkId])
    setProvider(this.nblBnbBlp, contractAddresses.nblBnbBlp[networkId])
    setProvider(this.earnNblMaster, contractAddresses.earnNblMaster[networkId])
    ;[
      ...this.pools,
      ...this.poolsV2,
      ...this.petPools,
      ...this.bPetPools,
      ...this.weaponPools,
      ...this.bestPools,
      ...this.weaponnftPools,
      ...this.petNftPools,
      ...this.helmetNftPools,
      ...this.springMasterPools,
      ...this.wSOTEMasterPools,
      ...this.SHIELDMasterPools,
      ...this.BRYMasterPools,
      ...this.DEFI100MasterPools,
      ...this.DEFI100OLDMasterPools,
      ...this.BananaMasterPools,
      ...this.seascapeNftPools,
      ...this.pCWSMasterPools,
      ...this.warMasterPools,
      ...this.war2MasterPools,
      ...this.tokocryptoNftPools,
      ...this.hatNftPools,
      ...this.dieselMasterPools,
      ...this.mxMasterPools,
      ...this.aliceMasterPools,
      ...this.aliceNftPools,
      ...this.bondlyNftPools,
      ...this.tctMasterPools,
      ...this.dfyMasterPools,
      ...this.gfxMasterPools,
      ...this.xDittoMasterPools,
      ...this.sactMasterPools,
      ...this.pet3Pools,
      ...this.hyfiPools,
      ...this.ginuPools,
      ...this.levPools,
      ...this.bondlyPools,
      ...this.bondly2Pools,
      ...this.tkoPools,
      ...this.tkoNftPools,
      ...this.bakeMuskMixerNftPools,
      ...this.oneInchBakeNftPools,
      ...this.tko2Pools,
      ...this.bnrgPools,
      ...this.tsaPools,
      ...this.tlmPools,
      ...this.xdittoNftPools,
      ...this.doggyTlmPools,
      ...this.barkTlmPools,
      ...this.tokauTlmPools,
      ...this.toyNftPools,
      ...this.bmoncNftPools,
      ...this.gatTlmPools,
      ...this.wsgPools,
      ...this.dogoPools,
      ...this.toynftEarnPools,
      ...this.bethMasterPools,
      ...this.tokauPools,
      ...this.eggPools,
      ...this.kalataPools,
      ...this.donPools,
      ...this.ntPools,
      ...this.moniPools,
      ...this.kxaPools,
      ...this.nblPools
    ].forEach(({ lpContract, lpAddress, tokenContract, tokenAddress }) => {
      setProvider(lpContract, lpAddress)
      setProvider(tokenContract, tokenAddress)
    })
    ;[...this.eth2MasterPools, ...this.aethMasterPools, ...this.aethAndEth2Pools].forEach(
      ({ lpContract, lpAddress, tokenAddresses }) => {
        setProvider(lpContract, lpAddress)
        tokenAddresses.forEach(({ tokenContract, tokenAddress }) => {
          setProvider(tokenContract, tokenAddress)
        })
      }
    )
  }

  setDefaultAccount(account) {
    this.sushi.options.from = account
    this.masterChef.options.from = account
  }

  async callContractFunction(method, options) {
    const { confirmations, confirmationType, autoGasMultiplier, ...txOptions } = options

    if (!this.blockGasLimit) {
      await this.setGasLimit()
    }

    if (!txOptions.gasPrice && this.defaultGasPrice) {
      txOptions.gasPrice = this.defaultGasPrice
    }

    if (confirmationType === Types.ConfirmationType.Simulate || !options.gas) {
      let gasEstimate
      if (this.defaultGas && confirmationType !== Types.ConfirmationType.Simulate) {
        txOptions.gas = this.defaultGas
      } else {
        try {
          gasEstimate = await method.estimateGas(txOptions)
        } catch (error) {
          const data = method.encodeABI()
          const { from, value } = options
          const to = method._parent._address
          error.transactionData = { from, value, data, to }
          throw error
        }

        const multiplier = autoGasMultiplier || this.autoGasMultiplier
        const totalGas = Math.floor(gasEstimate * multiplier)
        txOptions.gas = totalGas < this.blockGasLimit ? totalGas : this.blockGasLimit
      }

      if (confirmationType === Types.ConfirmationType.Simulate) {
        const g = txOptions.gas
        return { gasEstimate, g }
      }
    }

    if (txOptions.value) {
      txOptions.value = new BigNumber(txOptions.value).toFixed(0)
    } else {
      txOptions.value = '0'
    }

    const promi = method.send(txOptions)

    const OUTCOMES = {
      INITIAL: 0,
      RESOLVED: 1,
      REJECTED: 2
    }

    let hashOutcome = OUTCOMES.INITIAL
    let confirmationOutcome = OUTCOMES.INITIAL

    const t = confirmationType !== undefined ? confirmationType : this.confirmationType

    if (!Object.values(Types.ConfirmationType).includes(t)) {
      throw new Error(`Invalid confirmation type: ${t}`)
    }

    let hashPromise
    let confirmationPromise

    if (t === Types.ConfirmationType.Hash || t === Types.ConfirmationType.Both) {
      hashPromise = new Promise((resolve, reject) => {
        promi.on('error', error => {
          if (hashOutcome === OUTCOMES.INITIAL) {
            hashOutcome = OUTCOMES.REJECTED
            reject(error)
            const anyPromi = promi
            anyPromi.off()
          }
        })

        promi.on('transactionHash', txHash => {
          if (hashOutcome === OUTCOMES.INITIAL) {
            hashOutcome = OUTCOMES.RESOLVED
            resolve(txHash)
            if (t !== Types.ConfirmationType.Both) {
              const anyPromi = promi
              anyPromi.off()
            }
          }
        })
      })
    }

    if (t === Types.ConfirmationType.Confirmed || t === Types.ConfirmationType.Both) {
      confirmationPromise = new Promise((resolve, reject) => {
        promi.on('error', error => {
          if (
            (t === Types.ConfirmationType.Confirmed || hashOutcome === OUTCOMES.RESOLVED) &&
            confirmationOutcome === OUTCOMES.INITIAL
          ) {
            confirmationOutcome = OUTCOMES.REJECTED
            reject(error)
            const anyPromi = promi
            anyPromi.off()
          }
        })

        const desiredConf = confirmations || this.defaultConfirmations
        if (desiredConf) {
          promi.on('confirmation', (confNumber, receipt) => {
            if (confNumber >= desiredConf) {
              if (confirmationOutcome === OUTCOMES.INITIAL) {
                confirmationOutcome = OUTCOMES.RESOLVED
                resolve(receipt)
                const anyPromi = promi
                anyPromi.off()
              }
            }
          })
        } else {
          promi.on('receipt', receipt => {
            confirmationOutcome = OUTCOMES.RESOLVED
            resolve(receipt)
            const anyPromi = promi
            anyPromi.off()
          })
        }
      })
    }

    if (t === Types.ConfirmationType.Hash) {
      const transactionHash = await hashPromise
      if (this.notifier) {
        this.notifier.hash(transactionHash)
      }
      return { transactionHash }
    }

    if (t === Types.ConfirmationType.Confirmed) {
      return confirmationPromise
    }

    const transactionHash = await hashPromise
    if (this.notifier) {
      this.notifier.hash(transactionHash)
    }
    return {
      transactionHash,
      confirmation: confirmationPromise
    }
  }

  async callConstantContractFunction(method, options) {
    const m2 = method
    const { blockNumber, ...txOptions } = options
    return m2.call(txOptions, blockNumber)
  }

  async setGasLimit() {
    const block = await this.web3.eth.getBlock('latest')
    this.blockGasLimit = block.gasLimit - SUBTRACT_GAS_LIMIT
  }
}
